import src from "IMAGE";
export default { src, width: 831, height: 501, blurWidth: 0, blurHeight: 0};
